const formatScore = num => num.toFixed(2).replace('.', ',')
const formatMaxScore = num => formatScore(num).replace(/,00$/, '').replace(/,0$/, '')

module.exports = {
  formatScore,
  formatMaxScore,
}
